import React, { Component } from 'react';
import Button from '../button/button';
import EventCarousel from '../../views/vantage/event-components/carousel';
import { EventHeaderDescription } from '../../views/vantage/event-components/content-types';
import { OffsetBootstrapColumnWrapper } from '../../views/vantage/event-components/layout';
import ShareReportModal from '../share-report-modal';
import HighlightsCheckBox from '../highlights-checkbox';
import { DEBUG_MODE } from '../../app-constants';
import { Desktop, Mobile } from '../../app-responsive';

export const SlidesWrapper = ({ children }) => (
  <div className="slides grid-12px d-flex flex-row flex-wrap row">
    {children}
  </div>
);

class TripReport extends Component {
  constructor(props) {
    super(props);

    const {
      updateSelectedSlides,
      tripReportSlides: {
        selected,
      },
    } = this.props;

    this.state = {
      shareModalIsOpen: false,
      totalSelectedHighlights: selected.length,
    };

    updateSelectedSlides(selected);
  }

  highlightsCheckBoxStateChanged = ({ checked, id }) => {
    const {
      selectedSlides,
      updateSelectedSlides,
    } = this.props;

    const newSelectedSlides = !checked
      ? selectedSlides.filter(slideId => slideId !== id)
      : [...selectedSlides, id];

    updateSelectedSlides(newSelectedSlides);
    this.updateSelectedSlidesTally(newSelectedSlides);
  };

  updateSelectedSlidesTally = (selectedSlides) => {
    const {
      tripReportSlides: {
        selected,
        unselected,
      },
    } = this.props;

    this.setState({
      totalSelectedHighlights: selectedSlides.filter(slide => selected.indexOf(slide) > -1).length +
        selectedSlides.filter(slide => unselected.indexOf(slide) > -1).length,
    });
  };

  handleEventPDFDownload = () => {
    const {
      downloadEventReportAction,
      uId,
      eventId,
      selectedSlides,
    } = this.props;
    downloadEventReportAction({
      data: {
        uId,
        selected: [...selectedSlides],
      },
    },
    eventId);
  };

  handleClearAllSelectedSlides = () => {
    const { updateSelectedSlides } = this.props;
    updateSelectedSlides([]);
    this.updateSelectedSlidesTally([]);
  };

  handleShareReportOpen = () => {
    this.setState({ shareModalIsOpen: true });
  };

  handleShareReportClose = () => {
    this.setState({ shareModalIsOpen: false });
  };

  handleSendEmail = (emailList) => {
    const {
      sendEmailAction,
      uId,
      selectedSlides,
      eventId,
    } = this.props;

    sendEmailAction({
      data: {
        emailIdsList: [...emailList],
        selectedSlidesList: [...selectedSlides],
        userId: uId,
      },
    },
    eventId);
  };

  render() {
    const {
      tripReport: {
        highlightsHeading,
        downloadReportButtonText,
        emailReportButtonText,
        description,
        eventsDictionary,
        clearAllButtonText,
      },
      tripReportSlides: {
        selected,
        unselected,
      },
      shareReport,
      downloadTripReportIsLoading,
      emailTripReportIsSending,
      selectedSlides,
      showGenericErrorModal,
    } = this.props;

    const {
      totalSelectedHighlights,
    } = this.state;

    const makeHighlightsCheckBox = (slide, desktopClasses = true) => (
      <HighlightsCheckBox
        checked={selectedSlides.includes(slide)}
        checkBoxChanged={this.highlightsCheckBoxStateChanged}
        slideId={slide}
        highlightsContent={eventsDictionary[slide]}
        key={slide}
        desktopClasses={desktopClasses ? 'col-12 col-sm-4' : ''}
      />
    );

    const mapSlideCollection = slides => slides
      .filter(slide => eventsDictionary[slide])
      .map((slide) => {
        if (eventsDictionary[slide]) {
          return makeHighlightsCheckBox(slide);
        }
        if (DEBUG_MODE) {
          console.log(`${slide} is not present in eventdictionary`); // eslint-disable-line
        }
        return null;
      });

    const mapSlidesToCarousel = (slides) => {
      const newHighlightsSlide = slide => ({ highlightsCarouselSlides: slide ? [slide] : [] });
      // initialise all slides object
      const allHighlightCarouselSlides = [newHighlightsSlide()];
      const numberOfHighlightsPerSlide = 4;
      slides.forEach((slide) => {
        const currentCarouselSlide = allHighlightCarouselSlides[allHighlightCarouselSlides.length - 1].highlightsCarouselSlides;
        if (currentCarouselSlide.length < numberOfHighlightsPerSlide) {
          currentCarouselSlide.push(makeHighlightsCheckBox(slide, false));
        } else {
          allHighlightCarouselSlides.push(
            newHighlightsSlide(
              makeHighlightsCheckBox(slide, false),
            ),
          );
        }
      });
      return allHighlightCarouselSlides;
    };

    const tripReportCarouselMobileWrapper = contentToMap => (
      <div className="mb-4">
        <EventCarousel
          mobile
          contentToMap={contentToMap}
          cardsPerSlideMobile={1}
          wrapInCard={false}
          autoPlay={false}
        />
      </div>
    );

    const selectedHighlightsSlides = mapSlideCollection(selected);
    const unSelectedHighlightsSlides = mapSlideCollection(unselected);
    const selectedAndUnselectedForMobile = [...selected, ...unselected];
    const selectedAndUnselectedHighlightsSlidesMobile = mapSlidesToCarousel(selectedAndUnselectedForMobile);

    return (
      <React.Fragment>
        <OffsetBootstrapColumnWrapper columnsWide={10} wrapInRow>
          <EventHeaderDescription description={description} />
        </OffsetBootstrapColumnWrapper>
        <div className="row">
          <div className="col-12">
            <h4 className="highlights-heading">{highlightsHeading} ({totalSelectedHighlights}/{selected.length + unselected.length})</h4>
            <Desktop>
              <SlidesWrapper>
                {selectedHighlightsSlides}
                {unSelectedHighlightsSlides}
              </SlidesWrapper>
            </Desktop>
            <Mobile>
              {tripReportCarouselMobileWrapper(selectedAndUnselectedHighlightsSlidesMobile)}
            </Mobile>
          </div>
          <div className="col-12 text-right">
            <Button
              className="button clear"
              buttonText={clearAllButtonText}
              onClick={this.handleClearAllSelectedSlides}
            />
          </div>
        </div>
        <div className="row">
          <div className="col d-flex flex-column flex-sm-row justify-content-sm-end align-items-end cta">
            <Button
              className={`button do-business ${downloadTripReportIsLoading ? 'loading' : ''}`}
              buttonText={downloadReportButtonText}
              onClick={this.handleEventPDFDownload}
            />
            <Button
              className="button primary"
              buttonText={emailReportButtonText}
              onClick={this.handleShareReportOpen}
            />
            <ShareReportModal
              shareReport={shareReport}
              modalIsOpen={this.state.shareModalIsOpen}
              closeModal={this.handleShareReportClose}
              onSendEmail={this.handleSendEmail}
              clearAllButtonText={clearAllButtonText}
              emailTripReportIsSending={emailTripReportIsSending}
              showGenericErrorModal={showGenericErrorModal}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TripReport;
